import { useLocation, useNavigate } from 'react-router-dom';
import { routeStorage } from '../routes/routeStorage';
import { useEffect } from 'react';
import { ONBOARDING_ROUTE } from '../routes/routes';
import { notifyDismissible } from '../components/showNotification';
import { CustomFormattedMessage } from '../i18n/i18n';
import { PaymentPartnerType } from '../codegen/vehicles';

export enum ExternalAuthSources {
  EDENRED = 'edenred',
  PACE = 'pace',
}

export type ExternalOnboardingStatus = 'SUCCESS' | 'FAILED' | 'CANCELLED';

export const RedirectPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const redirectSource = queryParams.get(
    'source',
  ) as ExternalAuthSources | null;
  const selectedPaymentPartner = queryParams.get(
    'paymentPartner',
  ) as PaymentPartnerType | null;
  const externalOnboardingStatus = queryParams.get(
    'externalOnboardingStatus',
  ) as ExternalOnboardingStatus | null;

  useEffect(() => {
    const initialRoute = routeStorage.getRoute();
    let route = initialRoute ?? '/';

    if (redirectSource) {
      if (Object.values(ExternalAuthSources).includes(redirectSource)) {
        const storedVehicleId = routeStorage.getLastVehicleId();
        const externalLoginError = routeStorage.getExternalLoginError();

        if (storedVehicleId) {
          const addNewCardDialog =
            redirectSource === ExternalAuthSources.EDENRED
              ? PaymentPartnerType.UtaPayment
              : selectedPaymentPartner;

          route = `${ONBOARDING_ROUTE}?vehicleId=${storedVehicleId}&editDialog=SERVICE_CARDS&addNewCardDialog=${addNewCardDialog}`;

          if (externalOnboardingStatus) {
            route = route.concat(
              `&externalOnboardingStatus=${externalOnboardingStatus}`,
            );
          }

          if (externalLoginError) {
            route = route.concat(`&externalLoginError=${externalLoginError}`);
          }
          routeStorage.clearLastVehicleId();
          routeStorage.clearExternalLoginError();
        }
      } else {
        notifyDismissible(
          'error',
          <CustomFormattedMessage
            id={
              'base.body.notificationBanner.oauthRedirectFailureMessage.unknownSource'
            }
          />,
          'base.body.notificationBanner.oauthRedirectFailureTitle',
        );
      }
    }

    navigate(route, { replace: true });
  }, [redirectSource, navigate]);

  return <></>;
};
